import React from 'react';
import Link from 'next/link';
import Layout1x1 from 'components/Layout1x1';
import { withPageStaticProps } from 'utils/header';

class SmsTermsAndConditions extends React.Component {
  render() {
    return (
      <>
        <Layout1x1 className="m-section-hero">
          <h1 className="text-h2-display">SMS Terms of Service</h1>

          <h2 className="text-h4 text-gray-dark">Last Updated: January 4, 2022</h2>

          <p>
            The Menguin mobile message service (the "Service") is operated by us. Your use of the Service constitutes your agreement to
            these terms and conditions (“Mobile Terms”). We may modify or cancel the Service or any of its features without notice. To the
            extent permitted by applicable law, we may also modify these Mobile Terms at any time and your continued use of the Service
            following the effective date of any such changes shall constitute your acceptance of such changes.
          </p>

          <p>
            You understand that you do not have to sign up for this program in order to make any purchases, and your consent is not a
            condition of any purchase with Menguin. Your participation in this program is completely voluntary.
          </p>

          <p>
            We do not charge for the Service, but you are responsible for all charges and fees associated with text messaging imposed by
            your wireless provider. Message frequency varies. Message and data rates may apply. Check your mobile plan and contact your
            wireless provider for details. You are solely responsible for all charges related to SMS/text messages, including charges from
            your wireless provider.
          </p>

          <p>
            You may opt-out of the Service at any time. Text the single keyword command STOP to MNGUIN (
            <a href="sms:664846?body=STOP">664-846</a>). You'll receive a one-time opt-out confirmation text message. No further messages
            will be sent to your mobile device, unless initiated by you. If you have subscribed to other Menguin mobile message programs and
            wish to cancel, except where applicable law requires otherwise, you will need to opt out separately from those programs by
            following the instructions provided in their respective mobile terms. If you are experiencing issues with the Service you can
            reply with the keyword HELP for more assistance, or you can get help directly at <a href="tel:18446364846">1.844.636.4846</a> or{' '}
            <a href="mailto:help@menguin.com">email us</a>.
          </p>

          <p>
            We may change any short code or telephone number we use to operate the Service at any time and will notify you of these changes.
            You acknowledge that any messages, including any STOP or HELP requests, you send to a short code or telephone number we have
            changed may not be received and we will not be responsible for honoring requests made in such messages.
          </p>

          <p>
            The wireless carriers supported by the Service are not liable for delayed or undelivered messages. You agree to provide us with
            a valid mobile number. If you get a new mobile number, you will need to sign up for the program with your new number.
          </p>

          <p>
            To the extent permitted by applicable law, you agree that we will not be liable for failed, delayed, or misdirected delivery of
            any information sent through the Service, any errors in such information, and/or any action you may or may not take in reliance
            on the information or Service.
          </p>

          <p>
            We respect your right to privacy. To see how we collect and use your personal information, please see our{' '}
            <Link href="/support/privacy-policy" as="/support/privacy-policy">
              Privacy Notice
            </Link>
            .
          </p>
        </Layout1x1>
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default SmsTermsAndConditions;
